/* unplugin-vue-components disabled */import { render } from "./pro_info.vue?vue&type=template&id=f9a1b8f2&scoped=true"
import script from "./pro_info.vue?vue&type=script&lang=js"
export * from "./pro_info.vue?vue&type=script&lang=js"

import "./pro_info.vue?vue&type=style&index=0&id=f9a1b8f2&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9a1b8f2"]])

export default __exports__